export const pt = {
  // Navigation
  schedule: 'Horário',
  employees: 'Funcionários',
  vacations: 'Férias e Ausências',
  holidays: 'Feriados',
  store: 'Loja',
  statistics: 'Estatísticas',
  export: 'Exportar',
  mySchedule: 'Meu Horário',
  
  // Common actions
  save: 'Salvar',
  cancel: 'Cancelar',
  delete: 'Excluir',
  edit: 'Editar',
  add: 'Adicionar',
  close: 'Fechar',
  back: 'Voltar',
  next: 'Próximo',
  previous: 'Anterior',
  search: 'Pesquisar',
  filter: 'Filtrar',
  clear: 'Limpar',
  confirm: 'Confirmar',
  loading: 'Carregando...',
  
  // Authentication
  login: 'Entrar',
  logout: 'Sair',
  username: 'Nome de usuário',
  password: 'Senha',
  loginError: 'Nome de usuário ou senha inválidos',
  scheduleSystem: 'Sistema de Horários',
  loginWithCredentials: 'Entre com seu nome de usuário e senha',
  loggingIn: 'Entrando...',
  testInformation: 'Informações de Teste',
  
  // Store
  storeSelector: 'Seletor de Loja',
  selectStore: 'Selecione uma loja',
  newStore: 'Nova Loja',
  storeName: 'Nome da Loja',
  address: 'Endereço',
  phone: 'Telefone',
  email: 'E-mail',
  createStore: 'Criar Loja',
  editStore: 'Editar Loja',
  deleteStore: 'Excluir Loja',
  storeCreated: 'Loja criada com sucesso',
  storeUpdated: 'Loja atualizada com sucesso',
  storeDeleted: 'Loja excluída com sucesso',
  storeSettings: 'Configurações da Loja',
  weeklySchedule: 'Horário Semanal',
  scheduleExceptions: 'Exceções de Horário',
  addException: 'Adicionar Exceção',
  editScheduleException: 'Editar Exceção de Horário',
  addScheduleException: 'Adicionar Exceção de Horário',
  updateException: 'Atualizar Exceção',
  reasonOptional: 'Motivo (opcional)',
  openingHours: 'Horário de Funcionamento',
  noExceptionsConfigured: 'Nenhuma exceção configurada',
  date: 'Data',
  
  // Employees
  employeeName: 'Nome Completo',
  weeklyLimit: 'Limite Semanal (horas)',
  color: 'Cor do Funcionário',
  role: 'Função do Funcionário',
  manager: 'Gerente',
  employee: 'Funcionário',
  districtManager: 'Gerente de Distrito',
  employeeStartDate: 'Data de Início',
  birthday: 'Data de Nascimento',
  vacationDays: 'Dias de Férias por Ano',
  unavailableTimes: 'Horários Indisponíveis',
  addEmployee: 'Adicionar Funcionário',
  editEmployee: 'Editar Funcionário',
  deleteEmployee: 'Excluir Funcionário',
  employeeCreated: 'Funcionário criado com sucesso',
  employeeUpdated: 'Funcionário atualizado com sucesso',
  employeeDeleted: 'Funcionário excluído com sucesso',
  newEmployee: 'Novo Funcionário',
  regularEmployee: 'Funcionário Regular',
  mainManager: 'Gerente Principal',
  uniqueUsernameForLogin: 'Nome de usuário único para login do funcionário',
  passwordForLogin: 'Senha para login do funcionário',
  employeeList: 'Lista de Funcionários',
  active: 'Ativo',
  inactive: 'Inativo',
  create: 'Criar',
  update: 'Atualizar',
  manageEmployeeInfo: 'Gerencie as informações dos seus funcionários',
  
  // Schedule
  week: 'Semana',
  month: 'Mês',
  day: 'Dia',
  monday: 'Segunda-feira',
  tuesday: 'Terça-feira',
  wednesday: 'Quarta-feira',
  thursday: 'Quinta-feira',
  friday: 'Sexta-feira',
  saturday: 'Sábado',
  sunday: 'Domingo',
  startTime: 'Hora de Início',
  endTime: 'Hora de Fim',
  hours: 'Horas',
  duration: 'Duração',
  published: 'Publicar',
  draft: 'Rascunho',
  addShift: 'Criar Turnos',
  editShift: 'Editar Turno',
  deleteShift: 'Excluir Turno',
  copyWeek: 'Copiar Semana',
  repeatWeek: 'Repetir',
  deleteWeek: 'Excluir Semana',
  compactMode: 'Modo Compacto',
  normalMode: 'Modo Normal',
  thisWeek: 'Esta Semana',
  copying: 'Copiando...',
  clickEmployeeToCreateShift: 'Clique em um funcionário para criar um turno manualmente',
  view24h: 'Visualizar 24h',
  
  // Absences
  absenceManagement: 'Gerenciamento de Ausências',
  absenceType: 'Tipo de Ausência',
  vacation: 'Férias',
  sick: 'Licença Médica',
  personal: 'Pessoal',
  other: 'Outro',
  absenceStartDate: 'Data de Início',
  absenceEndDate: 'Data de Fim',
  reason: 'Motivo',
  status: 'Status',
  pending: 'Pendente',
  approved: 'Aprovado',
  rejected: 'Rejeitado',
  newRequest: 'Nova Solicitação',
  requestSubmitted: 'Solicitação enviada com sucesso',
  remainingVacationDays: 'Dias de Férias Restantes',
  type: 'Tipo',
  dates: 'Datas',
  days: 'Dias',
  actions: 'Ações',
  absenceTypeLabel: 'Tipo de Ausência',
  startDate: 'Data de Início',
  endDate: 'Data de Fim',
  employeeInfo: 'Informações do Funcionário',
  requestDate: 'Data da Solicitação',
  approvedBy: 'Aprovado por:',
  rejectedBy: 'Rejeitado por:',
  rejectionReason: 'Motivo da rejeição:',
  manageAllAbsenceRequests: 'Gerenciar todas as solicitações de ausência',
  totalAbsences: 'Total de Ausências',
  allTypes: 'Todos os tipos',
  allStatuses: 'Todos os status',
  allEmployees: 'Todos os funcionários',
  requestDetails: 'Detalhes da Solicitação',
  name: 'Nome',
  absenceInformation: 'Informações de Ausência',
  scheduleRestrictions: 'Restrições de horário',
  shiftPendingPublication: 'turno pendente de publicação',
  shiftsPendingPublication: 'turnos pendentes de publicação',
  defineOpeningHoursAndExceptions: 'Definir horário de funcionamento e exceções',
  open: 'Aberto',
  closed: 'Fechado',
  opens: 'Abre',
  closes: 'Fecha',
  range: 'Intervalo',
  addRange: 'Adicionar intervalo',
  addAnotherRange: 'Adicionar outro intervalo',
  lastSynchronization: 'Última sincronização',
  holidayInformation: 'Informações de Feriados',
  nationalHolidaysSyncAutomatically: 'Os feriados nacionais são sincronizados automaticamente a cada ano. Esses dias são automaticamente considerados dias não úteis no planejamento de horários.',
  
  // Statistics
  coverageAndWorkloadMetrics: 'Métricas de cobertura e carga de trabalho',
  activeEmployees: 'Funcionários Ativos',
  shiftsThisWeek: 'Turnos Esta Semana',
  totalHours: 'Total de Horas',
  statisticsByEmployee: 'Estatísticas por Funcionário',
  assignedHours: 'Horas Atribuídas',
  weeklyCap: 'Limite Semanal',
  utilization: '% Utilização',
  busiestDay: 'Dia Mais Movimentado',
  daysWithoutWeekend: 'Dias Sem Fim de Semana',
  
  // Export
  exportSchedules: 'Exportar Horários',
  exportPublishedSchedulesInDifferentFormats: 'Exportar horários publicados em diferentes formatos',
  ical: 'iCal',
  google: 'Google',
  noPublishedSchedulesToExport: 'Nenhum horário publicado para exportar',
  
  // Additional UI elements
  newAbsenceRequest: 'Nova Solicitação de Ausência',
  selectEmployee: 'Selecionar funcionário',
  describeAbsenceReason: 'Descreva o motivo da ausência...',
  submitting: 'Enviando...',
  submitRequest: 'Enviar Solicitação',
  vacationsAndAbsences: 'Férias e Ausências',
  requestVacation: 'Solicitar Férias',
  newVacationRequest: 'Nova Solicitação de Férias',
  myVacationRequests: 'Minhas Solicitações de Férias',
  clickRequestVacationToCreateFirstRequest: 'Clique em "Solicitar Férias" para criar sua primeira solicitação',
  vacationManagement: 'Gerenciamento de Férias',
  vacationRequests: 'Solicitações de Férias',
  
  // Absence Types
  sickness: 'Licença Médica',
  unjustified: 'Ausência Injustificada',
  special: 'Licença Especial',
  
  // Holidays
  holidayName: 'Nome do Feriado',
  holidayDate: 'Data do Feriado',
  addHoliday: 'Adicionar',
  editHoliday: 'Editar Feriado',
  automaticHolidayManagement: 'Gerenciamento automático de feriados nacionais',
  addCustomHoliday: 'Adicionar Feriado Personalizado',
  editCustomHoliday: 'Editar Feriado Personalizado',
  updateHoliday: 'Atualizar Feriado',
  nationalHolidays: 'Feriados Nacionais',
  loadingHolidays: 'Carregando feriados...',
  deleteHoliday: 'Excluir Feriado',
  
  // Statistics
  totalEmployees: 'Total de Funcionários',
  totalShifts: 'Total de Turnos',
  averageHours: 'Média de Horas',
  coverageProblems: 'Problemas de Cobertura',
  noProblems: 'Nenhum problema de cobertura detectado',
  gap: 'Lacuna',
  conflict: 'Conflito',
  overtime: 'Hora Extra',
  emptyDay: 'Sem turnos',
  weeklyOvertime: 'Hora extra semanal',
  storeClosed: 'Loja fechada',
  
  // Export
  exportData: 'Exportar Dados',
  selectDateRange: 'Selecionar Intervalo de Datas',
  from: 'De',
  to: 'Até',
  exportFormat: 'Formato de Exportação',
  excel: 'Excel',
  csv: 'CSV',
  exportSuccess: 'Dados exportados com sucesso',
  
  // Configuration
  configuration: 'Configuração',
  language: 'Idioma da Aplicação',
  country: 'País (para feriados)',

  // Header
  scheduleAdministrationPanel: 'Painel de Administração de Horários',
  welcome: 'Bem-vindo',
  invalidDay: 'Dia inválido',

  // Keyboard Shortcuts
  keyboardShortcuts: 'Atalhos de Teclado',
  showHideShortcutsHelp: 'Mostrar/ocultar ajuda de atalhos',
  toggleDarkMode: 'Alternar modo escuro',
  closeModalsAndPanels: 'Fechar modais e painéis',
  openNotificationCenter: 'Abrir centro de notificações',
  goToScheduleTab: 'Ir para a aba Horários',
  goToEmployeesTab: 'Ir para a aba Funcionários',
  goToConfigurationTab: 'Ir para a aba Configuração',
  goToStatisticsTab: 'Ir para a aba Estatísticas',
  goToExportTab: 'Ir para a aba Exportar',
  createNewShift: 'Criar novo turno',
  saveSchedules: 'Salvar horários',
  publishSchedules: 'Publicar horários',
  navigateBetweenWeeks: 'Navegar entre semanas',
  zoomInOut: 'Zoom in/out',
  resetZoom: 'Redefinir zoom',
  addNewEmployee: 'Adicionar novo funcionário',
  searchEmployees: 'Pesquisar funcionários',
  saveEmployee: 'Salvar funcionário',
  cancelEdit: 'Cancelar edição',
  refreshStatistics: 'Atualizar estatísticas',
  exportStatistics: 'Exportar estatísticas',
  refreshSchedules: 'Atualizar horários',
  pressCtrlSlashToShowHideHelp: 'Pressione Ctrl + / para mostrar/ocultar esta ajuda',

  // Keyboard Shortcut Categories
  general: 'Geral',
  navigation: 'Navegação',
  schedules: 'Horários',

  // Coverage Problems
  gapWithoutCoverage: 'Lacuna sem cobertura de',
  excessiveWorkday: 'Jornada excessiva',
  noShifts: 'Sem turnos',
  excessiveWeeklyHours: 'Horas semanais excessivas',
  problem: 'Problema',
  
  // Notifications
  notifications: 'Notificações',
  noNotifications: 'Nenhuma notificação',
  birthdayToday: 'Aniversário hoje',
  reviewAssignments: 'Revisar atribuições',
  verifyAllEmployeesHaveAssignedSchedules: 'Verificar se todos os funcionários têm horários atribuídos',
  notification: 'notificação',
  
  // Errors
  error: 'Erro',
  success: 'Sucesso',
  warning: 'Aviso',
  info: 'Informação',
  required: 'Este campo é obrigatório',
  invalidDate: 'Data inválida',
  invalidTime: 'Hora inválida',
  networkError: 'Erro de rede. Tente novamente.',
  
  // Confirmations
  confirmDelete: 'Tem certeza de que deseja excluir este item?',
  confirmDeleteWeek: 'Tem certeza de que deseja excluir todos os turnos desta semana? Esta ação não pode ser desfeita.',
  confirmDeleteAll: 'Tem certeza de que deseja excluir TODOS os dados? Esta ação excluirá todas as lojas, funcionários e turnos. Esta ação não pode ser desfeita.',
  
  // Time formats
  timeFormat: 'HH:MM',
  defaultDateFormat: 'DD/MM/AAAA',
  
  // Days of week
  daysOfWeek: {
    monday: 'Seg',
    tuesday: 'Ter',
    wednesday: 'Qua',
    thursday: 'Qui',
    friday: 'Sex',
    saturday: 'Sáb',
    sunday: 'Dom'
  },

  // Store Management
  storeManagement: 'Gerenciamento de Lojas',
  welcomeSelectStore: 'Bem-vindo, {name}. Selecione uma loja para gerenciar ou crie uma nova.',
  activeStores: 'Lojas Ativas',
  storeList: 'Lista de Lojas',
  generateTestData: 'Gerar Dados de Teste',
  noStoresYet: 'Nenhuma loja criada ainda',
  createFirstStore: 'Crie sua primeira loja para começar a gerenciar horários e funcionários.',
  storeAddress: 'Endereço',
  storePhone: 'Telefone',
  storeEmail: 'E-mail',
  storeNamePlaceholder: 'Ex: Loja Central',
  storeAddressPlaceholder: 'Ex: Rua Principal 123',
  storePhonePlaceholder: 'Ex: +55 11 1234 5678',
  storeEmailPlaceholder: 'Ex: loja@empresa.com',
  editStoreTitle: 'Editar Loja',
  createStoreTitle: 'Criar Nova Loja',
  storeNameRequired: 'Nome da loja é obrigatório',
  confirmDeleteStore: 'Tem certeza de que deseja excluir a loja "{storeName}"? Esta ação não pode ser desfeita.',
  shifts: 'Turnos',
  manageStore: 'Gerenciar Loja',

  // Date Format
  dateFormat: 'Formato de Data',
  dateFormatDDMMYYYY: 'DD/MM/AAAA',
  dateFormatMMDDYYYY: 'MM/DD/AAAA',
  dateFormatYYYYMMDD: 'AAAA/MM/DD',

  // Employee Dashboard
  mySchedules: 'Meus Horários',
  welcomeEmployee: 'Bem-vindo, {name}',
  previousWeek: 'Semana Anterior',
  nextWeek: 'Próxima Semana',
  thisMonth: 'Este Mês',
  myShifts: 'Meus Turnos',
  shiftCalendar: 'Calendário de Turnos',
  list: 'Lista',
  calendar: 'Calendário',
  noShiftsThisWeek: 'Você não tem turnos atribuídos esta semana',
  noShiftsThisMonth: 'Você não tem turnos atribuídos este mês',
  previousMonth: 'Mês Anterior',
  nextMonth: 'Próximo Mês',
  closeSession: 'Sair'
};
